import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ContentSwitch } from 'Components';
import { getSubdomain0FromPath, getSubdomain1FromPath, getIndexFromTabs } from 'helpers/urls';
import history from 'src/history';
import HeadDesktop from './HeadDesktop/HeadDesktop';

class Head extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(i) {
    const subDomain0 = getSubdomain0FromPath();
    const projectName = getSubdomain1FromPath();
    const { keys, tabs } = this.props;
    let location = tabs[keys[i]];
    if (projectName) location = `/${subDomain0}/${encodeURIComponent(projectName)}${location}`;

    history.push(location);
  }

  render() {
    const { props, state } = this;
    const sharedProps = {
      isGlobalSearch: this.props.location.search.includes('searchType'),
      handleClick: this.handleClick,
      tabs: this.props.keys,
      headIndex: getIndexFromTabs(this.props.keys || []),
    };

    return (
      <ContentSwitch index={props.deviceIndex} {...state} {...props} {...sharedProps}>
        <div />
        <HeadDesktop />
      </ContentSwitch>
    );
  }
}

Head.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func,
  }),
  tabs: PropTypes.shape({}),
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  keys: PropTypes.arrayOf(PropTypes.string),
};

export default Head;



// WEBPACK FOOTER //
// ./src/containers/Head/Head.jsx